import i from "../utils.es.js";
function o(r) {
  return i.isObject(r) && r.isAxiosError === !0;
}
export {
  o as default
};
